import { FilterDropdown } from "../../../components/StyledTable/filterFunctions";
import { SelectContainer } from "./User.style";
import { DateComponent } from "../../../components/DateComponent";
import styled from "styled-components";
import { LuFilterX } from "react-icons/lu";
import ActionBtnU from "./components/ActionBtnU";
interface ComponentProps {
  where?: any;
  incidentTypeData?: any[];
  incidentTypeFilter: string;
  setIncidentTypeFilter?: (incidentType: string) => void;
  incidentStatusData?: any[];
  incidentStatusFilter?: string;
  setIncidentStatusFilter?: (incidentStatus: string) => void;
  incidentFacilityData?: any[];
  handleClearFilter?: any;
  incidentTypeParam?: boolean;
  facilityNameParam?: boolean;
  searchable?: boolean;
  clearReactSelect: boolean;
  draft?: boolean;
  genIncidentFacilityFilter: any;
  setGenIncidentFacilityFilter: any;
  draftIncidentFacilityFilter: any;
  setDraftIncidentFacilityFilter: any;
  draftIncidentTypeFilter: any;
  setDraftIncidentTypeFilter: any;
  startDate: string;
  endDate: string;
  setStartDate: (startDate: string) => void;
  setEndDate: (endDate: string) => void;
  deletedFacilityFilter: string;
  setDeletedFacilityFilter: (fac: string) => void;
  deletedTypeFilter: string;
  setDeletedTypeFilter: (type: string) => void;
  deletedStatusFilter: string;
  setDeletedStatusFilter: (type: string) => void;
}
export const ClearFilterContainer = styled.div`
  /* display: flex;
  @media screen and (min-width: 901px) {
    grid-area: clearFilterBtn;
  } */
  /* @media screen and (min-width: 435px) and (max-width: 960px) {
    grid-area: clearFilterBtn;
  } */
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    /* display: flex;
    justify-content: center; */
    /* margin-top: 10px;
    margin-bottom: 10px; */
  }
`;
const PosWrapper = styled.div`
  /* @media screen and (min-width: 961px) {
    display: flex;
    position: relative;
    width: 100%;
  } */
  @media screen and (min-width: 435px) and (max-width: 960px) {
    /* display: grid;
    grid-template-areas:
      "selectContainer selectContainer"
      "dateContainer clearFilterBtn";
    grid-template-columns: 1fr 1fr; */
  }
`;
const DynamicFilterContainer = styled.div`
  /* @media screen and (max-width: 960px) { */
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  width: 100%;
  /* } */
`;
export const div = styled.div`
  @media screen and (min-width: 961px) {
    grid-area: selectContainer;

    display: flex;
    width: 100%;
    margin-bottom: 15px;
  }
  @media screen and (min-width: 436px) and (max-width: 960px) {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 435px) {
    width: 100%;
    display: grid !important;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    margin-bottom: 20px;
  }
  @media screen and (max-width: 320px) {
    flex-direction: column;
    margin-bottom: 10px;
  }
`;
const FiltersContainer = styled.div`
  margin-top: 25px;
  display: flex;
  width: 100%;
  @media only screen and (max-width: 1024px) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    height: auto;
    align-items: center;
  }
`;
const FilterComponentGeneral = ({
  where,
  incidentTypeData,
  incidentTypeFilter,
  setIncidentTypeFilter,
  incidentStatusData,
  incidentStatusFilter,
  setIncidentStatusFilter,
  incidentFacilityData,
  handleClearFilter,
  incidentTypeParam = false,
  facilityNameParam = false,
  searchable = false,
  clearReactSelect,
  draft,
  genIncidentFacilityFilter,
  setGenIncidentFacilityFilter,
  draftIncidentFacilityFilter,
  setDraftIncidentFacilityFilter,
  draftIncidentTypeFilter,
  setDraftIncidentTypeFilter,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  deletedFacilityFilter,
  setDeletedFacilityFilter,
  deletedTypeFilter,
  setDeletedTypeFilter,
  deletedStatusFilter,
  setDeletedStatusFilter,
}: ComponentProps) => {
  return (
    <PosWrapper>
      <DynamicFilterContainer>
        {/* xl:w-[233px] */}
        {/* className="mt-5 mb-5 lg:flex lg:flex-row lg:flex-wrap lg:items-center" */}
        <FiltersContainer>
          <DateComponent
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
          />
          {where === "incidentList" && (
            <>
              <SelectContainer className="flex w-full flex-col text-sm">
                <FilterDropdown
                  className="text-sm"
                  id="select-incident-type"
                  where={where}
                  placeholder="Select Type"
                  value={
                    incidentTypeFilter ||
                    incidentTypeParam ||
                    deletedFacilityFilter
                  }
                  options={incidentTypeData}
                  disabled={incidentTypeParam}
                  onChange={(e: any) => {
                    if (searchable && setIncidentTypeFilter)
                      setIncidentTypeFilter(e.value);
                  }}
                  searchable={searchable}
                  clearReactSelect={clearReactSelect}
                />
              </SelectContainer>

              <SelectContainer className="flex w-full flex-col">
                <FilterDropdown
                  id="select-status"
                  where={where}
                  placeholder="Select Status"
                  value={incidentStatusFilter}
                  options={incidentStatusData}
                  onChange={(e: any) => {
                    if (searchable && setIncidentStatusFilter)
                      setIncidentStatusFilter(e.value);
                  }}
                  searchable={searchable}
                  clearReactSelect={clearReactSelect}
                />
              </SelectContainer>

              <SelectContainer className="flex w-full flex-col">
                <FilterDropdown
                  id="select-facility"
                  where={where}
                  placeholder="Select Facility"
                  value={genIncidentFacilityFilter || facilityNameParam}
                  options={incidentFacilityData}
                  disabled={facilityNameParam}
                  onChange={(e: any) => {
                    if (searchable && setGenIncidentFacilityFilter)
                      setGenIncidentFacilityFilter(e.value);
                  }}
                  searchable={searchable}
                  clearReactSelect={clearReactSelect}
                />
              </SelectContainer>
            </>
          )}
          {where === "deletedList" && (
            <>
              <SelectContainer className="flex flex-col xl:w-[233px]">
                <FilterDropdown
                  id="select-incident-type"
                  where={where}
                  placeholder="Select Type"
                  value={deletedTypeFilter}
                  options={incidentTypeData}
                  onChange={(e: any) => {
                    if (searchable && setDeletedTypeFilter)
                      setDeletedTypeFilter(e.value);
                  }}
                  searchable={searchable}
                  clearReactSelect={clearReactSelect}
                />
              </SelectContainer>

              <SelectContainer className="flex flex-col xl:w-[233px]">
                <FilterDropdown
                  id="select-status"
                  where={where}
                  placeholder="Select  Status"
                  value={deletedStatusFilter}
                  options={incidentStatusData}
                  onChange={(e: any) => {
                    if (searchable && setDeletedStatusFilter)
                      setDeletedStatusFilter(e.value);
                  }}
                  searchable={searchable}
                  disabled
                  clearReactSelect={clearReactSelect}
                />
              </SelectContainer>

              <SelectContainer className="flex flex-col xl:w-[233px]">
                <FilterDropdown
                  id="select-facility"
                  where={where}
                  placeholder="Select  Facility"
                  value={deletedFacilityFilter}
                  options={incidentFacilityData}
                  onChange={(e: any) => {
                    if (searchable && setDeletedFacilityFilter)
                      setDeletedFacilityFilter(e.value);
                  }}
                  searchable={searchable}
                  clearReactSelect={clearReactSelect}
                />
              </SelectContainer>
            </>
          )}
          {where === "draftIncidentList" && (
            <>
              <SelectContainer className="flex flex-col xl:w-[233px]">
                <FilterDropdown
                  id="select-incident-type"
                  where={where}
                  placeholder="Select Type"
                  value={draftIncidentTypeFilter}
                  options={incidentTypeData}
                  disabled={incidentTypeParam}
                  onChange={(e: any) => {
                    if (searchable && setDraftIncidentTypeFilter)
                      setDraftIncidentTypeFilter(e.value);
                  }}
                  searchable={searchable}
                  clearReactSelect={clearReactSelect}
                />
              </SelectContainer>
              <SelectContainer className="flex flex-col xl:w-[233px]">
                <FilterDropdown
                  id="select-facility"
                  where={where}
                  placeholder="Select Facility"
                  value={draftIncidentFacilityFilter}
                  options={incidentFacilityData}
                  onChange={(e: any) => {
                    if (searchable && setDraftIncidentFacilityFilter)
                      setDraftIncidentFacilityFilter(e.value);
                  }}
                  searchable={searchable}
                  clearReactSelect={clearReactSelect}
                />
              </SelectContainer>
            </>
          )}
          <ClearFilterContainer>
            <ActionBtnU
              className="flex w-full items-center justify-center bg-purple-300"
              color="white"
              onClick={() => handleClearFilter()}
            >
              <span className="inline xl:hidden">Clear Filters</span>
              <LuFilterX className="hidden xl:inline" size={20} />
            </ActionBtnU>
          </ClearFilterContainer>
        </FiltersContainer>
      </DynamicFilterContainer>
    </PosWrapper>
  );
};

export default FilterComponentGeneral;
